import styled from '@emotion/styled';

export const Container = styled.div`
  .ant-checkbox-group {
    width: 100%;
  }
  .ant-form-item {
    margin-bottom: 5px;
  }
  .ant-list-item {
    align-items: center;
    border-bottom: 1px solid #eee;
    
    .ant-list-item-meta {
      align-items: center;
    }
  }
  .ant-checkbox-group, .ReactVirtualized__List {
    outline: none;
  }
  .ant-list-header {
    padding-top: 0;
  }
  .ant-spin-nested-loading {
    max-height: 500px;
    overflow: auto;
  }
`;